export default __webpack_public_path__ + "static/media/GCT_main.0f7e6c85.png";